import {
  Avatar,
  Box,
  Button,
  Grid,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  Link,
  Show,
  TextInput,
  useRecordContext,
  useRefresh,
} from "react-admin";
import React from "react";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import HmSubHeaderTitle from "../unit/HmSubHeaderTitle";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { styled } from "@mui/material/styles";
import sendRequest from "../dataProvider/sendRequest";
import CustomButtonCancel from "../unit/CustomButtonCancel";
import CustomButtonSave from "../unit/CustomButtonSave";
import FilePreviewField from "../unit/FilePreview";
import useNotify from "../unit/useNotify";
const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
const CustomBankerName = () => {
  const record = useRecordContext();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: "10px 0",
        //自动换行
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
      }}
    >
      <HmSubHeaderTitle title={record?.bankerName ? record?.bankerName : ""} />
      <HmSubHeaderTitle
        title={record?.created_at ? record?.created_at : ""}
        sx={{ fontSize: "14px" }}
      />
    </Box>
  );
};

const HMCommentLogo = () => {
  return (
    <img
      src="/images/hm.png"
      style={{
        marginLeft: 0,
        width: "45px",
        height: "45px",
        borderRadius: "15px",
      }}
      height="45px"
      width="45px"
    />
  );
};
const RequestdataComment = () => {
  const record = useRecordContext();
  const comment = record?.comments;
  if (!comment || comment.length === 0) {
    return null;
  }
  return (
    <>
      {comment.map((c: any, index: number) => (
        <Grid
          container
          sx={{ width: "100%", borderTop: "1px solid #e0e0e3" }}
          key={index}
        >
          <Grid item xs={2} md={2}>
            <Box sx={{ width: "100%", p: "20px" }}>
              {c?.bankerEmail == "support@happymangocredit.com" ? (
                <HMCommentLogo />
              ) : (
                <Avatar sx={{ marginLeft: 0, width: "40px", height: "40px" }} />
              )}

              <>
                <HmSubHeaderTitle title={c?.bankerName ? c?.bankerName : ""} />
                <HmSubHeaderTitle
                  title={c?.created_at ? c?.created_at : ""}
                  sx={{ fontSize: "14px" }}
                />
              </>
            </Box>
          </Grid>
          <Grid item xs={10} md={10}>
            <Box sx={{ width: "100%", p: "20px" }}>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {c?.sComment}
              </Typography>

              {c?.files && c?.files.length > 0 && (
                <>
                  {c?.files.map((file: any, fileIndex: number) => (
                    <FilePreviewField
                      id={file.id}
                      title={file.title}
                      // src={file.src}
                      // key={fileIndex}
                    />
                  ))}
                </>
              )}
            </Box>
          </Grid>
        </Grid>
      ))}
    </>
  );
};

const ShowRequestFiles = () => {
  const record = useRecordContext();
  const files = record?.files || [];
  if (!files || files.length === 0) {
    return null;
  }

  return (
    <Box sx={{ width: "100%", p: "20px" }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Uploaded Files
      </Typography>
      <Grid container spacing={2}>
        {files.map((file: any, index: number) => (
          <Grid item xs={12} sm={12} md={12} key={index}>
            <FilePreviewField
              id={file.id}
              title={file.title}
              // src={file.src}
              // fileName={file.fileName}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
const ShowRequestContent = () => {
  const record = useRecordContext();
  return (
    <>
      <TextField
        label="Application ID"
        value={record?.iApplicationId || ""}
        fullWidth
        variant="outlined"
        margin="normal"
        InputProps={{
          readOnly: true,
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
            backgroundColor: "#eeee",
          },
        }}
      />
      <TextField
        label="Loan Number"
        value={record?.sLoanNum || ""}
        fullWidth
        variant="outlined"
        margin="normal"
        InputProps={{
          readOnly: true,
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
            backgroundColor: "#eeee",
          },
        }}
      />
      <TextField
        label="Description"
        value={record?.sDescription || ""}
        fullWidth
        variant="outlined"
        margin="normal"
        multiline
        rows={8}
        InputProps={{
          readOnly: true,
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
            backgroundColor: "#eeee",
          },
        }}
      />
    </>
  );
};

const RequestClosed = () => {
  const record = useRecordContext();
  const refresh = useRefresh();
  const reqId = record?.id;
  const authrole = localStorage.getItem("authrole");
  const rawStatus = record?.sStatus;
  const displayStatus =
    rawStatus === "Pending"
      ? "In Progress"
      : rawStatus === "Closed"
      ? "Closed"
      : rawStatus || "";
  const statusColor =
    rawStatus === "Pending"
      ? "#ed6c02"
      : rawStatus === "Closed"
      ? "#2e7d32"
      : "gray";

  const handleClose = async () => {
    // console.log("Comment Data:", commentData);
    const reqUrl = `requestdata/actions/close`;
    const response = await sendRequest(reqUrl, {
      id: reqId,
      data: [],
    });
    if (response && response.code === 200) {
      refresh();
      // setComment("");
      // setCommentError("");
      // setFilelist([]);
      //set sComment textfield value to empty
      // document.getElementById("reqAddCommentText")!.value = "";
    } else {
      // setCommentError(response?.message || "Failed to update");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        mt: 2,
        mr: 2,
      }}
    >
      {/* 在左侧显示当前request status */}
      <Typography
        variant="body1"
        color="textSecondary"
        sx={{
          fontSize: "16px",
          color: statusColor,
          fontWeight: "bold",
          ml: 2,
        }}
      >
        {displayStatus}
      </Typography>
      {authrole == "admin" && rawStatus !== "Closed" && (
        <CustomButtonCancel onClick={handleClose} label="Close" />
      )}
    </Box>
  );
};
const RequestdataCommentAdd = () => {
  const record = useRecordContext();
  const refresh = useRefresh();
  const [filelist, setFilelist] = React.useState<string[]>([]);
  const reqId = record?.id;
  const [comment, setComment] = React.useState("");
  const [commentError, setCommentError] = React.useState("");
  const authrole = localStorage.getItem("authrole");

  if (record?.sStatus == "Closed") {
    return (
      <Typography
        variant="body2"
        color="textSecondary"
        sx={{
          p: 2,
          borderTop: "1px solid #e0e0e3",
          fontSize: "16px",
          color: "gray",
          fontWeight: "bold",
        }}
      >
        This request is closed. No further comments can be added.
      </Typography>
    );
  }

  const handleSaveComment = async (e: any) => {
    e.preventDefault();
    if (!comment || comment.trim() === "") {
      setCommentError("Comment cannot be empty");
      return false;
    }
    const commentData: any = {
      comment: comment,
      requestId: reqId,
      uploadfile: filelist?.join(";"),
    };
    // console.log("Comment Data:", commentData);
    const reqUrl = `requestdata/actions/addComment`;
    const response = await sendRequest(reqUrl, {
      id: reqId,
      data: commentData,
    });
    if (response && response.code === 200) {
      setComment("");
      setCommentError("");
      setFilelist([]);
      refresh();
    } else {
      setCommentError(response?.message || "Failed to update");
    }
  };

  // const handleClose = async () => {
  //   // console.log("Comment Data:", commentData);
  //   const reqUrl = `requestdata/actions/close`;
  //   const response = await sendRequest(reqUrl, {
  //     id: reqId,
  //     data: [],
  //   });
  //   if (response && response.code === 200) {
  //     refresh();
  //     setComment("");
  //     setCommentError("");
  //     setFilelist([]);
  //     //set sComment textfield value to empty
  //     document.getElementById("reqAddCommentText")!.value = "";
  //   } else {
  //     setCommentError(response?.message || "Failed to update");
  //   }
  // };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    let file = e.target.files[0];
    let fileAize = file.size / 1024;
    if (fileAize > 1024) {
      // errorNotify("File size should be less than 1MB");
      return false;
    }
    let fileNameType = file.name.split(".").pop();
    let fileType = ["pdf", "jpg", "jpeg", "png", "doc", "docx", "xls", "xlsx"];
    if (fileType.indexOf(fileNameType) == -1) {
      // errorNotify(
      //   "File type should be pdf, jpg, jpeg, png, doc, docx, xls, xlsx"
      // );
      return false;
    }
    let fileName = file.name;
    if (file) {
      const formData = new FormData();
      formData.append("commentDataUploadFile", file);

      const access_token = localStorage.getItem("access_token");
      const csrfToken = localStorage.getItem("csrfToken");
      fetch(
        `${import.meta.env.VITE_API_URL}/requestdata/actions/uploadFile/0`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${access_token}`,
            "X-CSRF-TOKEN": `${csrfToken}`,
          },
          body: formData,
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data?.code == 200) {
            // successNotify("File uploaded successfully");
            setFilelist((prev) => [...prev, data?.file]);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };
  return (
    <>
      <Box sx={{ width: "100%", p: "20px" }}>
        <TextField
          id="reqAddCommentText"
          label="Add Comment"
          variant="outlined"
          multiline={true}
          value={comment}
          rows={4}
          fullWidth
          required={true}
          onChange={(e: any) => {
            const value = e.target.value;
            setComment(value);
            if (!value || value.trim() === "") {
              setCommentError("Comment cannot be empty");
            } else {
              setCommentError("");
            }
          }}
          error={!!commentError}
          helperText={commentError}
        />
        {filelist.length > 0 && (
          <Box>
            {filelist.map((item) => (
              <Typography variant="subtitle1" sx={{ mb: 1 }} key={item}>
                Uploaded Files: {item}
              </Typography>
            ))}
          </Box>
        )}
        <Box
          sx={{
            display: "flex",
            justifyContent: "right",
          }}
        >
          <Button
            component="label"
            role={undefined}
            variant="contained"
            tabIndex={-1}
            startIcon={<CloudUploadIcon />}
            sx={{ width: "100%", maxWidth: "500px", mt: 1 }}
          >
            <VisuallyHiddenInput
              type="file"
              id="commentDataUploadFile"
              name="commentDataUploadFile"
              onChange={handleFileChange}
            />
          </Button>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            mt: 2,
          }}
        >
          <CustomButtonSave onClick={handleSaveComment} />
        </Box>
      </Box>
    </>
  );
};

const RequestdataShow = (props: any) => {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const refresh = useRefresh();
  const authrole = localStorage.getItem("authrole");
  return (
    <Show
      {...props}
      basePath="/requestdata"
      resource="requestdata"
      sx={{
        width: "100%",
        marginTop: "-10px",
        ".MuiPaper-root": { border: "none", borderRadiue: "none" },
      }}
    >
      <RequestClosed />

      <Grid container sx={{ width: "100%" }}>
        <Grid item xs={2} md={2}>
          <Box sx={{ width: "100%", p: "20px" }}>
            <Avatar />
            <CustomBankerName />
          </Box>
        </Grid>
        <Grid item xs={10} md={10}>
          <Box sx={{ width: "100%", p: "20px" }}>
            <ShowRequestContent />
          </Box>
          <Box sx={{ width: "100%" }}>
            <ShowRequestFiles />
          </Box>
        </Grid>
      </Grid>
      <hr />
      <Grid container sx={{ width: "100%" }}>
        <Grid item xs={2} md={2}>
          <Box
            sx={{
              width: "100%",
              height: "100%",
              p: "20px",
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "flex-start",
              pb: "10px",
              pl: "10px",
            }}
          >
            <Link to="/requestdata" style={{ textDecoration: "none" }}>
              <Tooltip title="Return to Request List" placement="left">
                <ArrowCircleLeftIcon color="primary" sx={{ mr: 1 }} />
              </Tooltip>
            </Link>
          </Box>
        </Grid>
        <Grid item xs={10} md={10}>
          <Box sx={{ width: "100%" }}>
            <RequestdataComment />
            <RequestdataCommentAdd />
          </Box>
        </Grid>
      </Grid>
    </Show>
  );
};

export default RequestdataShow;
